import styled from 'styled-components/macro';

const Row = styled.div`
	display: flex;
	flex-direction: row;
`;

export default Row;
